import React, {useState} from "react"
import {Button, Input} from "antd"
import * as S from "./ChatBox.styles"
import {SendOutlined} from '@ant-design/icons'
import ChatQuestion from "../ChatQuestion/ChatQuestion.component"
import ChatAnswer from "../ChatAnswer/ChatAnswer.component"

interface Props {
    visible: boolean
    handleClose: () => void
}

const ChatBox = ({visible, handleClose}: Props) => {

    const [answer, setAnswer] = useState<string>("");

    const Question = [
        {
            question_text: "What specific subject is your inquiry about?",
            question_answers: [
                {label: "Option A", value: "a"},
                {label: "Option B", value: "b"},
                {label: "Option C", value: "c"},
            ]
        }
    ];

    return (
        <S.ChatBoxModal closable={true}
                        title="Virtual Assistant"
                        visible={visible}
                        footer={null}
                        onCancel={() => {
                            handleClose()
                        }}>
            <S.Instructions><strong>Instructions:</strong> Use the panel below to describe your inquiry. Answer the
                questions bellow and the Virtual assistant will guide you throught the available
                solutions.</S.Instructions>
            <S.ChatBoxWrapper>
                <S.ChatMessages>
                    <ChatQuestion setAnswer={setAnswer} question={Question}/>
                    {answer ? <ChatAnswer answer={answer}/> : null}
                </S.ChatMessages>
            </S.ChatBoxWrapper>
            <S.InputWrapper>
                <S.InputButtons>
                    <Input type="text" placeholder="insert your message here..."/>
                    <Button type="primary"><SendOutlined/></Button>
                </S.InputButtons>
            </S.InputWrapper>
        </S.ChatBoxModal>
    )
};

export default ChatBox;
